import React, { useCallback, useContext, useEffect, useState } from "react";
import "../../scss/pages/admin/_leloregistration.scss";
import { useNavigate, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import leloContext from "../../context/leloreg/leloContext";
import errorLogger from "../ErrorLogger";
import { toast } from "react-toastify";


const R5Course = () => {
  const {
    formData,
    onFormDataChange,
    getLeloDataUuid,
    leloDatauuid,
    getCourses,
    leloCourse,
  } = useContext(leloContext);
  const {
    gradeLevel,
    courses = [],
    selectedCourseAgreements = [],
    selectedLearningCenter,
    charter_id,
    charter,
    understood1 = false,
    name,
    sesson_id,
    siteId,
  } = formData;
  const navigate = useNavigate();
  const location = useLocation();
  const { _uuid, pgRelationshipToStudent, _id, LeloRegistrationProfile, permalink } = location.state || {};
  const [FormSubmit, setFormSubmit] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [totalCourses, setTotalCourses] = useState("");
  const [highSchoolCourses, setHighSchoolCourses] = useState([]);
  const [middleSchoolCourses, setMiddleSchoolCourses] = useState([]);
  const [elementaryCourses, setElementaryCourses] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);


  // const learningCenterName = selectedLearningCenter;
  // const learningCenters = selectedLearningCenter


  // useEffect(() => {
  //   if (!charter_id) {
  //     alert("Something went wrong");
    
  //     if (_uuid === undefined) {
  //       history.push(`/forms/${permalink}/${_id}`);
  //     } else {
  //       history.push(`/forms/${permalink}/${_uuid}/${LeloRegistrationProfile}`);
  //     }
  //   }
  // }, [charter_id, history, permalink, LeloRegistrationProfile, _id, _uuid]);

  
  useEffect(() => {
    if (!charter_id) {
      toast.error("Something went wrong");

      if (_uuid === undefined) {
        navigate(`/forms/${permalink}`);
      } else {
        navigate(`/forms/${permalink}/${_uuid}`);
      }
    }
  }, [charter_id, navigate, permalink, LeloRegistrationProfile, _id, _uuid]);


  //first
  const handleGradeChange = (e) => {
    onFormDataChange({
      target: { name: "gradeLevel", value: e.target.value },
    });

    onFormDataChange({
      target: { name: "courses", value: [] },
    });
    onFormDataChange({
      target: { name: "selectedCourseAgreements", value: [] },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFormDataChange(e);
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setErrorMessage("");
    }
    onFormDataChange({
      target: { name: "understood1", value: checked },
    });
  };

  const courseFilledOut =
    gradeLevel && (["9", "10", "11", "12"].includes(gradeLevel) ? (isVisible ? understood1 : true) : true);

  const courseFilledOut1 =
    gradeLevel &&
    (["9", "10", "11", "12"].includes(gradeLevel)
      ? courses.length > 0 && courses.some(course => course.id) && (isVisible ? understood1 : true)
      : ["5", "6", "7", "8"].includes(gradeLevel)
        ? courses.length > 0 && courses.some(course => course.id)
        : ["TK", "KN", "1", "2", "3", "4"].includes(gradeLevel)
          ? courses.length > 0 && courses.some(course => course.id)
          : true);

  // Helper function to get CSS class for form validation
  const getInputClassName = (value) => {
    if (FormSubmit && !value) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  // Helper function for grade level select validation
  const getGradeLevelClassName = () => {
    if (FormSubmit && !gradeLevel) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  // Helper function for course select validation
  const getCourseSelectClassName = (index) => {
    if ((index === 0 || !index) && FormSubmit && !courseFilledOut1 && !courses[index]?.id) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  // Helper function for checkbox validation
  const getCheckboxClassName = () => {
    if (FormSubmit && !understood1) {
      return "checkbox-error";
    }
    return "checkbox-default";
  };

  const handleSubmit = () => {
    setFormSubmit(true);

    if (["9", "10", "11", "12"].includes(gradeLevel) && isVisible && !understood1) {
      setErrorMessage("You must understand the terms to proceed.");
      return;
    }
    setErrorMessage("");

    if (_uuid === undefined) {
      if (courseFilledOut1) {
        navigate("/leloStudent5", {
          state: {
            permalink,
            pgRelationshipToStudent,
            charter_id, selectedLearningCenter, name, _id, LeloRegistrationProfile
          }
        });
      }
    } else if (courseFilledOut) {
      navigate("/leloStudent5", {
        state: {
          permalink,
          _uuid,
          pgRelationshipToStudent,
          charter_id, selectedLearningCenter, name, _id, LeloRegistrationProfile
        }
      });
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (_uuid) {
      getLeloDataUuid(_uuid)
    }
  }, [])

  useEffect(() => {
    if (leloDatauuid?.data) {
      const site = leloDatauuid.data;
      if (site) {
        onFormDataChange({
          target: { name: "gradeLevel", value: site.gradeLevel || "" },
        });
        onFormDataChange({
          target: {
            name: "courses",
            value: site.courses.map((course) => ({
              id: course.id,
              course_name: course.course_name,
            })),
          },
        });

        const selectedCourseAgreements = Array.isArray(
          site.selectedCourseAgreements
        )
          ? site.selectedCourseAgreements
          : [];
        onFormDataChange({
          target: {
            name: "selectedCourseAgreements",
            value: selectedCourseAgreements,
          },
        });
      }
    }
  }, [leloDatauuid]);


  const getCourseInfo = () => {
    const filterCoursesByGrade = (courses) =>
      courses.filter((course) =>
        course.grade_level_offered.split(",").includes(gradeLevel)
      );



    if (["TK", "KN", "1", "2", "3", "4"].includes(gradeLevel)) {

      return {
        title: "Max Number of Elementary School Courses:",
      };
    } else if (["5", "6", "7", "8"].includes(gradeLevel)) {
      return {
        title: "Max Number of Middle School Courses:",
      };
    } else if (["9", "10", "11", "12"].includes(gradeLevel)) {
      return {
        title: "Max Number of High School Courses:",
      };
    }

    return { title: "", courses: [], maxCourses: 0 };
  };
  const { title } = getCourseInfo();

  const getCourseInfo1 = (site) => {
    const filterCoursesByGrade = (courses) =>
      courses.filter((course) =>
        course.grade_level_offered.split(",").includes(gradeLevel)
      );

    let totalCourses1 = 0;
    const siteArray = Array.isArray(site) ? site : [];

    if (["TK", "KN", "1", "2", "3", "4"].includes(gradeLevel)) {
      totalCourses1 =
        siteArray
          ?.map((item) => item.elementarySchoolDetails?.totalCourses)
          .filter((value) => value)?.[0] || 0;

      const filteredCourses = filterCoursesByGrade(elementaryCourses);

      return {
        title1: "Max Number of Elementary School Courses:",
        courses: filteredCourses,
        key: "elementaryCourses",
        totalCourses1,
        message:
          filteredCourses.length === 0
            ? "No courses available for this grade level"
            : null,
      };
    } else if (["5", "6", "7", "8"].includes(gradeLevel)) {
      totalCourses1 =
        siteArray
          ?.map((item) => item.middleSchoolDetails?.totalCourses)
          .filter((value) => value)?.[0] || 0;

      const filteredCourses = filterCoursesByGrade(middleSchoolCourses);

      return {
        title1: "Max Number of Middle School Courses:",
        courses: filteredCourses,
        key: "middleSchoolDetails",
        totalCourses1,
        message:
          filteredCourses.length === 0
            ? "No courses available for this grade level"
            : null,
      };
    } else if (["9", "10", "11", "12"].includes(gradeLevel)) {
      totalCourses1 =
        siteArray
          ?.map((item) => item.highSchoolDetails?.totalCourses)
          .filter((value) => value)?.[0] || 0;

      const filteredCourses = filterCoursesByGrade(highSchoolCourses);

      return {
        title1: "Max Number of High School Courses:",
        courses: filteredCourses,
        key: "highSchoolDetails",
        totalCourses1,
        message:
          filteredCourses.length === 0
            ? "No courses available for this grade level"
            : null,
      };
    }

    return {
      title1: "",
      courses: [],
      totalCourses1,
      message: "No courses available for this grade level",
    };
  };

  const {
    title1,
    courses: availableCourses,
    totalCourses1,
    message,
  } = getCourseInfo1(totalCourses);

  const fetchCourses = async () => {
    try {

      const courses = leloCourse.data

      setHighSchoolCourses(
        courses.filter((course) => course.course_type === "High School")
      );
      setMiddleSchoolCourses(
        courses.filter((course) => course.course_type === "Middle School")
      );
      setElementaryCourses(
        courses.filter((course) => course.course_type === "Elementary School")
      );
    } catch (error) {
      //console.error("Error fetching courses:", error);
      errorLogger.logError(error.message);
    }
  };
  useEffect(() => {
    fetchCourses();
  }, [leloCourse.data]);

  useEffect(() => {
      getCourses(siteId, charter_id, sesson_id);
  }, []);
 
  const NCCA = useCallback(() => {

    if (_uuid === undefined) {
      if (leloCourse?.data && charter_id && siteId && sesson_id) {
        const site = leloCourse.data.filter(
          (v) =>
            v.charter_id === charter_id &&
            siteId.includes(v.siteId) &&
            sesson_id.includes(v.LeloRegistrationProfile)
        );

        const hasNCAA = site.some((item) => item.highSchoolDetails?.includeNCAA === "Yes");

        setIsVisible(hasNCAA);
        setTotalCourses((prev) => (JSON.stringify(prev) !== JSON.stringify(site) ? site : prev));
      }
    } else {
      if (leloCourse?.data && charter_id && siteId && sesson_id) {
        const site = leloCourse.data.filter(
          (v) =>
            v.charter_id === charter_id &&
            siteId.includes(v.siteId) &&
            sesson_id.includes(v.LeloRegistrationProfile)
        );

        const hasNCAA = site.some((item) => item.highSchoolDetails?.includeNCAA === "Yes");
        
        setIsVisible(hasNCAA);
        setTotalCourses((prev) => (JSON.stringify(prev) !== JSON.stringify(site) ? site : prev));
      }
    }
  }, [_uuid, leloCourse, charter_id, , siteId, sesson_id]);
 
  useEffect(() => {
    NCCA();
  }, [leloCourse, charter_id, siteId, sesson_id, _uuid]);


  const handleCourseChange = (index, courseId) => {
    const { courses: availableCourses } = getCourseInfo1();

    if (
      index > 0 &&
      (!courses[index - 1]?.id || courses[index - 1]?.id === "")
    ) {
      toast.error(
        `Please select Course ${index} first before selecting Course ${index + 1
        }.`
      );
      return;
    }

    const selectedCourse = availableCourses.find(
      (course) => course._id === courseId
    );
    const updatedCourses = [...courses];
    updatedCourses[index] = {
      id: courseId,
      course_name: selectedCourse ? selectedCourse.course_name : "",
    };
    const updatedAgreements = [...selectedCourseAgreements];
    updatedAgreements[index] = selectedCourse
      ? selectedCourse.master_agreement_name
      : "";
     //console.log("Updated Courses:", updatedCourses);
    // console.log("Updated Agreements:", updatedAgreements);
    onFormDataChange({
      target: {
        name: "courses",
        value: updatedCourses,
      },
    });
    onFormDataChange({
      target: {
        name: "selectedCourseAgreements",
        value: updatedAgreements,
      },
    });
  };

  useEffect(() => {
    let updatedGrades = [];

    if (highSchoolCourses.length > 0) {
      updatedGrades = [...updatedGrades, "9", "10", "11", "12"];
    }
    if (middleSchoolCourses.length > 0) {
      updatedGrades = [...updatedGrades, "5", "6", "7", "8"];
    }
    if (elementaryCourses.length > 0) {
      updatedGrades = [...updatedGrades, "TK", "KN", "1", "2", "3", "4"];
    }

    // Define the correct grade order
    const gradeOrder = ["TK", "KN", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    // Sort `updatedGrades` based on `gradeOrder`
    updatedGrades.sort((a, b) => gradeOrder.indexOf(a) - gradeOrder.indexOf(b));

    setGradeLevels(updatedGrades);
  }, [highSchoolCourses, middleSchoolCourses, elementaryCourses]);

  if (_uuid === undefined) {
    return (
      <div className="sub-form">
        <h2>
          Registration for Classes <span>(6/7)</span>
          <hr />
        </h2>

        {/* Grade Level Selection */}
        <div className="item">
          <div className="asterisk-group">
            <h3>Grade Level:</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            value={gradeLevel || ""}
            onChange={handleGradeChange}
            className={getGradeLevelClassName()}
          >
            <option value="">Select Grade Level</option>
            {gradeLevels.length > 0
              ? gradeLevels.map((level) => (
                <option key={level} value={level}>
                  {level}
                </option>
              ))
              : null}
          </select>
        </div>

        <div className="note course-note">
          <p>
            <b>Note:</b> The charter school does not guarantee the completion of
            any courses or the number of credits that will be earned. By
            completing this registration form, I acknowledge that it is the
            responsibility of the parent/guardian and student to ensure that the
            student is taking the proper courses and that the student is working
            at a pace that will allow them to complete the course and earn the
            credits they plan to earn.
          </p>
        </div>
        <div className="item">
          {isVisible && ["9", "10", "11", "12"].includes(gradeLevel) && (
            <div>
              <h3>NCAA Notification</h3>
              <div className="ncaa-notification">
                The program that you/your student is registering for may or may
                not be NCAA approved. It is the sole responsibility of the
                parent/guardian and student to consult with their school
                counselor to determine if the program is NCAA approved and if
                the courses taken meet the student's needs.
              </div>
              <label>
                <input
                  type="checkbox"
                  checked={understood1}
                  value={understood1}
                  onChange={handleCheckboxChange}
                  className={getCheckboxClassName()}
                />
                &nbsp; I Understand
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </label>
              {errorMessage && (
                <div className="error-message">
                  {errorMessage}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Course Selection */}
        <div className="item">
          {gradeLevel && ( // Ensure a grade level is selected before showing courses or the message
            <>
              <h4>{title1}</h4>
              {message ? (
                <p className="no-courses-message">{message}</p>
              ) : (
                Array.from({ length: totalCourses1 }).map((_, index) => (
                  <div key={index} className="course-item">
                    <h3>Course {index + 1}</h3>
                    <select
                      value={courses[index]?.id || ""}
                      onChange={(e) =>
                        handleCourseChange(index, e.target.value)
                      }
                      className={getCourseSelectClassName(index)}
                    >
                      <option value="">Select Course</option>
                      {availableCourses
                        .filter(
                          (course) =>
                            !courses.some(
                              (selectedCourse, i) =>
                                selectedCourse?.id === course._id && i !== index
                            )
                        )
                        .map((course) => (
                          <option key={course._id} value={course._id}>
                            {course.course_name}
                          </option>
                        ))}
                    </select>
                    {selectedCourseAgreements[index] && (
                      <p>
                        <b>Agreement:</b>{" "}
                        {selectedCourseAgreements[index]}
                      </p>
                    )}
                  </div>
                ))
              )}
            </>
          )}
        </div>

        {/* Progress Buttons */}
        <div className="progress-btns">
          <div className="circle-btn" onClick={() => navigate(-1)}>
            <FaIcons.FaChevronLeft
              className="progress-level-btn"
              onClick={() => navigate(-1)}
            />
          </div>

          <div className="circle-btn" onClick={handleSubmit}>
            <FaIcons.FaChevronRight
              className="progress-level-btn"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="sub-form">
        <h2>
          Registration for Classes <span>(6/7)</span>
          <hr />
        </h2>

        {/* Grade Level Selection */}
        <div className="item">
          <div className="asterisk-group">
            <h3>What is the Student's Grade Level?</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="gradeLevel"
            value={gradeLevel}
            disabled
            onChange={handleChange}
            className={getInputClassName(gradeLevel)}
          />
        </div>

        <div className="note course-note">
          <p>
            <b>Note:</b> The charter school does not guarantee the completion of
            any courses or the number of credits that will be earned. By
            completing this registration form, I acknowledge that it is the
            responsibility of the parent/guardian and student to ensure that the
            student is taking the proper courses and that the student is working
            at a pace that will allow them to complete the course and earn the
            credits they plan to earn.
          </p>
        </div>
        <div className="item">
          {isVisible && ["9", "10", "11", "12"].includes(gradeLevel) && (
            <div>
              <h3>NCAA Notification</h3>
              <div className="ncaa-notification">
                The program that you/your student is registering for may or may
                not be NCAA approved. It is the sole responsibility of the
                parent/guardian and student to consult with their school
                counselor to determine if the program is NCAA approved and if
                the courses taken meet the student's needs.
              </div>
              <label>
                <input
                  type="checkbox"
                  checked={understood1}
                  value={understood1}
                  onChange={handleCheckboxChange}
                  className={getCheckboxClassName()}
                />
                &nbsp; I Understand
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </label>
              {errorMessage && (
                <div className="error-message">
                  {errorMessage}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Course Selection */}
        <div className="course-selection">
          <div className="item">
            <div className="asterisk-group">
              <h4>{title}</h4>
            </div>
          </div>
          {courses.map((course, index) => (
            <div className="item" key={index}>
              <h3>
                <input
                  type="text"
                  id={`course-${index}`}
                  name={`course-${index}`}
                  value={course?.course_name || ""}
                  disabled
                  onChange={(e) => {
                    const updatedCourses = [...courses];
                    updatedCourses[index] = {
                      id: course?.id,
                      course_name: e.target.value,
                    };
                    onFormDataChange({
                      target: { name: "courses", value: updatedCourses },
                    });
                  }}
                  required
                  className="course-input-disabled"
                />
              </h3>

              <div className="selected-course-agreements">
                {selectedCourseAgreements[index] ? (
                  <div className="agreement-item">
                    <b>Agreement:</b>&nbsp;
                    {selectedCourseAgreements[index]}
                  </div>
                ) : (
                  <div className="agreement-item no-agreement">
                    No agreement available for this course.
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Progress Buttons */}
        <div className="progress-btns">
          <div className="circle-btn" onClick={() => navigate(-1)}>
            <FaIcons.FaChevronLeft
              className="progress-level-btn"
              onClick={() => navigate(-1)}
            />
          </div>

          <div className="circle-btn" onClick={handleSubmit}>
            <FaIcons.FaChevronRight
              className="progress-level-btn"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
};

export default R5Course;